// extracted by mini-css-extract-plugin
export default {"container":"layout_container__UphYN","logo":"layout_logo__+dMkK"};